(function () {
  function init(root, jobs) {
    if (!root) return null;
    if (root.wcyExperience && root.wcyExperience.stage.isConnected) { (jobs || []).forEach(root.wcyExperience.registerJob); return root.wcyExperience; }
    var details = root.querySelector('.wcy-product-details');
    if (!details) return null;
    if (details.wcyExperience) { (jobs || []).forEach(details.wcyExperience.registerJob); return details.wcyExperience; }
    var nav = document.createElement('div');
    nav.className = 'wcy-product-tabs'; nav.setAttribute('role', 'tablist'); nav.setAttribute('aria-label', 'Produktinformation');
    var stage = document.createElement('div');
    stage.className = 'wcy-tab-stage wcy-icecat-live'; stage.setAttribute('data-faq-accordions', ''); stage.dataset.tabsOpenMethod = 'click';
    details.prepend(stage); details.prepend(nav); details.dataset.experience = 'tabs';
    var entries = [], active = null, touched = false;
    var prefix = root.id || 'wcy-product';
    function balanceTabs() {
      var visible = entries.filter(function (item) { return item.available; });
      entries.forEach(function (item) { item.button.classList.toggle('wcy-tab-wide', visible.length % 2 === 1 && item === visible[visible.length - 1]); });
    }
    function select(entry, focus) {
      if (!entry.available) return;
      active = entry;
      entries.forEach(function (item) {
        var selected = item === entry;
        item.button.setAttribute('aria-selected', String(selected)); item.button.tabIndex = selected ? 0 : -1;
        item.panel.dataset.active = String(selected); item.panel.setAttribute('aria-hidden', String(!selected)); item.panel.inert = !selected;
      });
      if (focus) entry.button.focus();
      window.dispatchEvent(new Event('resize'));
    }
    function add(key, label, node, available) {
      var existing = entries.find(function (item) { return item.key === key; });
      if (existing) {
        var duplicateHeading = node.querySelector('h2,h3,h5,h6'); if (duplicateHeading) duplicateHeading.hidden = true;
        node.classList.remove('yv-product-feature', 'yv-tab-pane', 'yv-product-detail-tab');
        if (node.tagName === 'DETAILS') node.open = true;
        existing.panel.appendChild(node); return existing;
      }
      var panel = document.createElement('section'); panel.className = 'wcy-tab-panel'; panel.id = prefix + '-panel-' + key;
      panel.setAttribute('role', 'tabpanel'); panel.dataset.active = 'false'; panel.setAttribute('aria-hidden', 'true'); panel.inert = true;
      var button = document.createElement('button'); button.type = 'button'; button.className = 'wcy-product-tab'; button.id = prefix + '-tab-' + key;
      button.textContent = label; button.setAttribute('role', 'tab'); button.setAttribute('aria-controls', panel.id); button.setAttribute('aria-selected', 'false'); button.tabIndex = -1; button.hidden = !available;
      panel.setAttribute('aria-labelledby', button.id);
      var entry = { key: key, panel: panel, button: button, available: available };
      button.addEventListener('click', function () { touched = true; select(entry); });
      button.addEventListener('keydown', function (event) {
        var visible = entries.filter(function (item) { return item.available; }); var index = visible.indexOf(entry), next;
        if (event.key === 'ArrowRight') next = visible[(index + 1) % visible.length];
        if (event.key === 'ArrowLeft') next = visible[(index + visible.length - 1) % visible.length];
        if (event.key === 'Home') next = visible[0]; if (event.key === 'End') next = visible[visible.length - 1];
        if (next) { event.preventDefault(); touched = true; select(next, true); }
      });
      node.classList.remove('yv-product-feature', 'yv-tab-pane', 'yv-product-detail-tab');
      if (node.tagName === 'DETAILS') node.open = true;
      panel.appendChild(node); stage.appendChild(panel); nav.appendChild(button); entries.push(entry);
      balanceTabs();
      if (available && !active) select(entry);
      return entry;
    }
    var observer = new ResizeObserver(function () {
      stage.style.setProperty('--wcy-panel-width', stage.getBoundingClientRect().width + 'px');
    });
    observer.observe(stage);
    var sources = Array.from(details.querySelectorAll('.yv-product-feature-content > .yv-product-feature, .yv-product-detail-tabs .yv-product-detail-tab'));
    if (!sources.length) sources = Array.from(details.querySelectorAll('.yv-product-accordion > details, .yv-product-accordion > .container > details'));
    sources.forEach(function (node, index) {
      var heading = node.querySelector('h2,h3,h5,h6,summary'); var label = (heading && heading.textContent || 'Produktinformation').trim();
      var content = node.cloneNode(true);
      content.querySelectorAll('h2,h3,h5,h6,summary,script,style').forEach(function (item) { item.remove(); });
      if (!content.textContent.trim() && !content.querySelector('img,video,iframe,table,model-viewer')) {
        node.hidden = true; return;
      }
      var specification = /specifikation|specification/i.test(label);
      var key = specification ? 'specifications' : /beskrivelse|description/i.test(label) ? 'description' : 'detail-' + index;
      add(key, specification ? 'Specifikationer' : label, node, true);
    });
    details.querySelectorAll('.yv-product-feature-list-wrapper, .yv-product-detail-tabs .yv-tabs-heading-wrapper, .yv-product-accordion, [data-wcy-rich-detail-nav]').forEach(function (node) {
      node.hidden = true; node.classList.add('wcy-retired-navigation');
      node.querySelectorAll('.yv-tab-product-item').forEach(function (item) { item.classList.remove('yv-tab-product-item'); });
    });
    var api = {
      stage: stage,
      registerJob: function (job) {
        if (job.experienceEntry || ['productstory', 'reasonstobuy', 'manuals'].indexOf(job.type) < 0) return;
        var label = job.type === 'productstory' ? 'Produktfortælling' : job.type === 'reasonstobuy' ? 'Produktfordele' : 'Dokumenter';
        job.experienceEntry = add(job.type, label, job.block, false);
        job.experience = api;
      },
      available: function (job) {
        var entry = job.experienceEntry; if (!entry || entry.available) return;
        entry.available = true; entry.button.hidden = false; if (job.block.tagName === 'DETAILS') job.block.open = true;
        if (job.type === 'productstory') { nav.prepend(entry.button); entries.splice(entries.indexOf(entry), 1); entries.unshift(entry); }
        balanceTabs();
        if (!active || (job.type === 'productstory' && !touched)) select(entry);
      }
    };
    root.wcyExperience = api; details.wcyExperience = api; (jobs || []).forEach(api.registerJob);
    // Move the original controls together; keep IDs, rules and variant refresh targets.
    var purchase = root.querySelector('[id^="ProductData-"]');
    var actions = purchase && purchase.querySelector('.pdp-action-container');
    var quantity = purchase && purchase.querySelector('[data-product-quantity-wrapper]');
    if (actions && quantity && quantity.querySelector('input[name="quantity"]')) {
      quantity.classList.add('wcy-inline-quantity');
      actions.classList.add('wcy-inline-purchase');
      actions.prepend(quantity);
    }
    var benefits = root.querySelector('.labtech-trustbox:not(#wcy-pdp-reviews)'); var reviews = root.querySelector('#wcy-pdp-reviews');
    if (benefits && reviews) { var trust = document.createElement('div'); trust.className = 'wcy-purchase-trust'; benefits.before(trust); trust.appendChild(benefits); trust.appendChild(reviews); }
    if (root.querySelector('.wcy-empty-gallery')) root.classList.add('wcy-no-product-image');
    var gallery = root.querySelector('.wcy-product-gallery');
    if (gallery && gallery.parentElement.classList.contains('row')) {
      root.classList.add('wcy-product-layout');
      gallery.parentElement.appendChild(details);
    }
    return api;
  }
  window.WcyProductExperience = { init: init };
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.wcy-product-details').forEach(function (node) { init(node.closest('.shopify-section') || node.parentElement); });
  });
})();
